import { DeadFamilyEntry } from "../types/DeadFamilyEntry";

/** Use demo dead families until on-chain enumeration is ready to ship. */
export const MOCK_DEAD_FAMILIES_ENABLED = true;

export const MOCK_DEAD_FAMILY_ENTRIES: DeadFamilyEntry[] = [
  {
    familyId: 906,
    name: "The Black Hand",
    donAddress: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb0",
    donName: "AldoVescari",
    memberCount: 18,
    leaveFee: 25_000,
    leaders: ["0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb0"],
  },
  {
    familyId: 905,
    name: "Corleone Syndicate",
    donAddress: "0x3f5CE5FBFe3E9af3971dD823D1523B0aC24c131a",
    donName: "VitoCorleone",
    memberCount: 24,
    leaveFee: 50_000,
    leaders: ["0x3f5CE5FBFe3E9af3971dD823D1523B0aC24c131a"],
  },
  {
    familyId: 904,
    name: "North Side Crew",
    donAddress: "0x8ba1f109551bD432803012645Ac136c22C177e9",
    donName: "PaulieWalnuts",
    memberCount: 11,
    leaveFee: 10_000,
    leaders: ["0x8ba1f109551bD432803012645Ac136c22C177e9"],
  },
  {
    familyId: 903,
    name: "The Commission",
    donAddress: "0x5aAeb6053F3E94C9b9A09f33669435E7Ef1BeAed",
    donName: "NicoBellandi",
    memberCount: 31,
    leaveFee: 75_000,
    leaders: ["0x5aAeb6053F3E94C9b9A09f33669435E7Ef1BeAed"],
  },
  {
    familyId: 902,
    name: "Little Italy",
    donAddress: "0x8626f6940E2eb28930eFb4CeF49B2d1F2C9C1199",
    donName: "Silvio",
    memberCount: 14,
    leaveFee: 20_000,
    leaders: ["0x8626f6940E2eb28930eFb4CeF49B2d1F2C9C1199"],
  },
  {
    familyId: 901,
    name: "Five Points",
    donAddress: "0x2546BcD3c84621e976D8185Aa27800a256bD1eC3",
    donName: "Adriana",
    memberCount: 9,
    leaveFee: 5_000,
    leaders: ["0x2546BcD3c84621e976D8185Aa27800a256bD1eC3"],
  },
];
